/*
 * The promotion pop-up (board SF 02; GUARDRAILS G9): under the title, until
 * when, and one line of what it does, both written from the offer's
 * settings and never typed, so the line says only what the server does
 * (mpgadmin G45). Pure: no clock, no screen.
 */
import type { Promotion } from '../types/promotion.types';
import { dayText, money, offText, ordinal } from './promotionTerms';

/** "Spring bath week · until 31 Dec", "Until 31 Dec", "No end date". */
export const popupWhen = (p: Pick<Promotion, 'caption' | 'endsOn'>): string => {
  const until = p.endsOn ? `until ${dayText(p.endsOn.slice(0, 10), false)}` : 'no end date';
  const caption = p.caption?.trim();
  return caption ? `${caption} · ${until}` : until[0].toUpperCase() + until.slice(1);
};

/** "$15 off what you pay at the salon on up to 3 bookings, with a $30 minimum spend." */
export const popupDoes = (p: Promotion): string => {
  // A deal on services says what it does in the server's words (mpgadmin G138).
  if (p.isServiceDeal && p.headline) return `${p.headline.trim().replace(/\.$/, '')}.`;
  const how =
    p.rebookWithinWeeks && p.rewardEveryNthVisit
      ? `every ${ordinal(p.rewardEveryNthVisit)} visit in a row, each within ${p.rebookWithinWeeks} weeks of the last`
      : p.rebookWithinWeeks
        ? `on each visit within ${p.rebookWithinWeeks} weeks of the last groom`
        : p.usesPerClient == null
          ? 'on every booking'
          : p.usesPerClient <= 1
            ? 'on one booking'
            : `on up to ${p.usesPerClient} bookings`;
  const min = p.minSpend && p.minSpend > 0 ? `, with a ${money(p.minSpend)} minimum spend` : '';
  return `${offText(p)} what you pay at the salon ${how}${min}.`;
};

/** Once claimed, in the pop-up. */
export const POPUP_CLAIMED = 'Claimed: it comes off what you pay at the salon when a booking fits.';
